module.exports = __webpack_public_path__ + "img/default_portrait_picture.46a41666.svg";